import React, { useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import Typography from '@visa/vds/typography';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Divider from '@visa/vds/divider';
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import MCSSpace from '../../../components/MCSSpace';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import { GlobalAlertContext } from '../../../context/GlobalAlertContext';
import BillingLineForm from './BillingLineForm';

import { SubscriptionApi } from '../../../services/subscription.service';
import { AdminRoutes } from '../../../_constants/PageRoutes';
import { AuthContext } from '../../../context/AuthContext';

function ManageBillingLinesDetails() {
    const location = useLocation();
    const history = useHistory();

    const [isLoaded, setIsLoaded] = useState(false);
    const [billingLine, setBillingLineDetail] = useState(null);
    const [saving, setSaving] = useState(false);
    const [formErrors, setFormErrors] = useState([]);

    React.useEffect(() => {
        setBillingLineDetail(location.state.billingLine);
        setIsLoaded(true);
    }, []);

    const billingLineReadOnly = (authData) => {
        if (authData && authData.user && authData.user.isSuperAdmin)
            return false;        
        return true;
    }

    function returnToBillingLinePage() {
        history.push(AdminRoutes.MANAGEBILLINGLINES);
    }

    const formIsValid = (alertObj) => {
        if (formErrors.length == 0)
            return true;

        let errorText = "Please fix the error(s) in the form.";
        //formErrors.forEach(value => {
        //    errorText += "<p>" + value.text +"</p>";
        //});
        alertObj.setErrorMessage(errorText);
        return false;
    };

    const updateBillingLine = async (alertObj) => {
        if (!formIsValid(alertObj)) {
            return;
        }

        setSaving(true);
        const updateResponse = await SubscriptionApi.UpdateBillingLine(billingLine.id, billingLine);
        if (!updateResponse) {
            alertObj.setErrorMessage("Billing Line failed to be updated.");
            setSaving(false);
        } else if (updateResponse) {
            alertObj.setSuccessMessage("Billing Line successfully updated.");
            // returnToBillingLinePage();
            setSaving(false);
        } else {
            alertObj.setErrorMessage("Billing Line failed to be updated: " + updateResponse);
            setSaving(false);
        }
    };

    return (
        <>
            { (!isLoaded || saving) && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {
                    alertObj => (
                        <AuthContext.Consumer>
                            {
                                data => (
                                    <>
                                        <Grid>
                                            <Row>
                                                <Col>
                                                    <Typography tag="h1">Manage Billing Lines - {billingLine?.lineNumber}</Typography>
                                                    <Divider type="standard" />
                                                </Col>
                                            </Row>
                                            <BillingLineForm ReadOnly={billingLineReadOnly(data)} billingLine={billingLine} setBillingLineDetail={setBillingLineDetail} formErrors={formErrors} setFormErrors={setFormErrors} />
                                            <MCSSpace />
                                            <Row>
                                                <Col>
                                                    <ButtonGroup direction="right">
                                                        <ButtonText colorScheme="secondary" onClick={returnToBillingLinePage}>Cancel</ButtonText>
                                                        { !billingLineReadOnly(data) &&
                                                            <ButtonText colorScheme="primary" onClick={() => updateBillingLine(alertObj)}>Save Changes</ButtonText>
                                                        }
                                                    </ButtonGroup>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </>
                                )}
                        </AuthContext.Consumer>
                    )
                }
            </GlobalAlertContext.Consumer>
        </>
    );
}

export default ManageBillingLinesDetails;